module.exports = __webpack_public_path__ + "static/media/Sunny_Kind.40670d87.gif";